<template>
  <div class="container">
    <h1>New Character</h1>
    <hr />
    <ez-input v-model="item.name" :error="errors['name']">Name</ez-input>
    <ez-text-area-md v-model="item.description" :error="errors['description']" :rows="4">Description</ez-text-area-md>
    <div class="text-center">
      <button class="btn btn-primary" @click="postData()">Save</button>
      <router-link class="btn btn-secondary" :to="`/characters`">Cancel</router-link>
    </div>
  </div>
</template>

<script>
import EzInput from "../shared/_VueEzInput.vue";
import EzTextAreaMd from "../shared/_VueEzTextAreaMd.vue";
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  name: "character-new",
  components: {
    EzInput,
    EzTextAreaMd
  },
  data() {
    return {
      item: {
        ruleset: null,
        name: null,
        description: null,
        image: null
      },
      errors: {}
    };
  },
  mounted() {
    this.$Progress.finish();
    this.$embers.pageData("New Character");
    this.item.ruleset = this.ruleset;
  },
  computed: {
    ...mapGetters(["isAdmin"]),
    ...mapState({
      ruleset: state => state.session.user.settings.ruleset
    })
  },
  methods: {
    ...mapActions({
      charactersCreate: "characters/create"
    }),
    async postData() {
      let schema = this.$store.state.schemas.sheets.find(
        x => x.ruleset === this.item.ruleset
      );
      if (!schema) {
        this.errors = { ruleset: { message: "Ruleset is required" } };
        console.error(this.errors);
      }
      this.item = Object.assign({}, this.item, schema);
      if (schema) {
        try {
          let res = await this.charactersCreate(this.item);
          this.$router.push({ path: `/characters/${res._id}/sheet` });
        } catch (err) {
          this.errors = Object.assign({}, this.errors, err.response.data);

          if (this.errors.message) {
            this.$toasted.global.app_error({
              message: this.errors.message
            });
          }
        }
      }
    }
  }
};
</script>
